import React from "react";
import { Nav } from "shards-react";

import UserActions from "./UserActions";

export default ({user}) => (
  <Nav navbar className="border-left flex-row">
    <UserActions user={user}/>
  </Nav>
);
